<template>
    <div class="container my-5">
        <b-form-select v-model="tur" class="mb-3">
            <b-form-select-option value="mektup">Mektup</b-form-select-option>
            <b-form-select-option value="kart">Kart</b-form-select-option>
        </b-form-select>
        <h5>Yapılan toplam {{tur}}: {{oHaftadaYapilanToplamBelge}}</h5>
        <b-table :busy="isBusy" class="table-responsive-sm" striped hover
                 :items="liste" :fields="fields">
            <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Saatsel Rapor Oluşturuluyor...</strong>
                </div>
            </template>
            <template v-slot:head()="scope">
                <div class="text-nowrap">
                    <span v-if="scope.column !== 'saat'" >{{scope.label}} ({{toplamlar[scope.column]}})</span>
                    <span v-else>{{scope.label}}</span>
                </div>
            </template>
        </b-table>
    </div>
</template>

<script>
    import {HaftalikSaatselRapor} from "@/api/belgeler";
    
    const initialToplam = {
        pzt : 0,
        sal: 0,
        car: 0,
        per: 0,
        cum: 0,
        cmt: 0,
        pzr: 0
    }
    
    export default {
        name: "HaftalikSaatselRapor",
        data() {
            return {
                oHaftadaYapilanToplamBelge: 0,
                isBusy: false,
                tur: 'mektup',
                liste: [],
                toplamlar: {...initialToplam }, 
                fields: [
                    { key: 'saat', label: 'Saat', sortable: true },
                    { key: 'pzt', label: 'Pzt', sortable: true },
                    { key: 'sal', label: 'Sal', sortable: true },
                    { key: 'car', label: 'Çar', sortable: true },
                    { key: 'per', label: 'Per', sortable: true },
                    { key: 'cum', label: 'Cum', sortable: true },
                    { key: 'cmt', label: 'Cmt', sortable: true },
                    { key: 'pzr', label: 'Pzr', sortable: true }
                ]
            }
        },
        methods: {
            async listeyiDoldur() {
                this.oHaftadaYapilanToplamBelge = 0
                this.toplamlar = { ...initialToplam }
                this.isBusy = true
                const tarih = this.$route.params.haftaBaslangic.split(".");
                const gun = tarih[0]
                const ay = tarih[1]
                const yil = tarih[2]

                const { sonuc, toplamlar, oHaftadaYapilanToplamBelge } = await HaftalikSaatselRapor(this.tur, `${yil}-${ay}-${gun}`)
                this.oHaftadaYapilanToplamBelge = oHaftadaYapilanToplamBelge
                this.liste = sonuc
                this.toplamlar = toplamlar
                this.isBusy = false
            }
        },
        watch: {
            'tur': async function() {
                await this.listeyiDoldur()
            }
        },
        async created() {
           await this.listeyiDoldur()
        }
    }
</script>

<style scoped>

</style>